// ** React Imports
import { lazy } from 'react';

const IllnessRoutes = [
  {
    path: 'illness',
    component: lazy(() => import('pages/illness')),
  },
];

export default IllnessRoutes;
